// src/data/slaData.js
export const slaData = [
  {
    customer: ["Orange DRC", "MTN Congo","TIM Brazil"],
    mappings: {
      "Critical|Critical": "2 Hours",
      "Critical|High": "2 Hours",
      "Critical|Medium": "4 Hours",
      "Critical|Low": "8 Hours",
      "High|Critical": "2 Hours",
      "High|High": "2 Hours",
      "High|Medium": "4 Hours",
      "High|Low": "8 Hours",
      "Medium|Critical": "4 Hours",
      "Medium|High": "4 Hours",
      "Medium|Medium": "4 Hours",
      "Medium|Low": "8 Hours",
      "Low|Critical": "8 Hours",
      "Low|High": "8 Hours",
      "Low|Medium": "8 Hours",
      "Low|Low": "8 Hours",
    },
  },
  {
    customer: [
      "Orange MALI",
"Orange Côte d'Ivoire",
      "Moov Niger",
      "SirusXM",
      "Pacific-IP",
      "BCEAO",
      "MTC Timor Leste",
"Telecom Namibia",
      "MTN SSD",
      "Zamani Niger",
      "Airtel DRC",
      "Solomon Telekom",
      "WPDI South Sudan",
      "WPDI Uganda",
      "Asecna",
      "MTC Namibia",
    ],
    mappings: {
      "Critical|Critical": "4 Hours",
      "Critical|High": "8 Hours",
      "Critical|Medium": "36 Hours",
      "Critical|Low": "7 Days",
      "High|Critical": "8 Hours",
      "High|High": "8 Hours",
      "High|Medium": "36 Hours",
      "High|Low": "7 Days",
      "Medium|Critical": "36 Hours",
      "Medium|High": "36 Hours",
      "Medium|Medium": "36 Hours",
      "Medium|Low": "7 Days",
      "Low|Critical": "7 Days",
      "Low|High": "7 Days",
      "Low|Medium": "7 Days",
      "Low|Low": "7 Days",
    },
  },
  {
    customer: ["Conecel"],
    mappings: {
      "Critical|Critical": "2 Hours",
      "Critical|High": "4 Hours",
      "Critical|Medium": "8 Hours",
      "Critical|Low": "7 Days",
      "High|Critical": "4 Hours",
      "High|High": "4 Hours",
      "High|Medium": "8 Hours",
      "High|Low": "7 Days",
      "Medium|Critical": "8 Hours",
      "Medium|High": "8 Hours",
      "Medium|Medium": "8 Hours",
      "Medium|Low": "7 Days",
      "Low|Critical": "7 Days",
      "Low|High": "7 Days",
      "Low|Medium": "7 Days",
      "Low|Low": "7 Days",
    },
  },
  {
    customer: ["Claro Nicaragua"],
    mappings: {
      "Critical|Critical": "8 Hours",
      "Critical|High": "16 Hours",
      "Critical|Medium": "24 Hours",
      "Critical|Low": "36 Hours",
      "High|Critical": "16 Hours",
      "High|High": "16 Hours",
      "High|Medium": "24 Hours",
      "High|Low": "36 Hours",
      "Medium|Critical": "24 Hours",
      "Medium|High": "24 Hours",
      "Medium|Medium": "24 Hours",
      "Medium|Low": "36 Hours",
      "Low|Critical": "36 Hours",
      "Low|High": "36 Hours",
      "Low|Medium": "36 Hours",
      "Low|Low": "36 Hours",
    },
  },
  {
    customer: ["Deutsche Telekom"],
    mappings: {
      "Critical|Critical": "12 Hours",
      "Critical|High": "24 Hours",
      "Critical|Medium": "36 Hours",
      "Critical|Low": "7 Days",
      "High|Critical": "24 Hours",
      "High|High": "24 Hours",
      "High|Medium": "36 Hours",
      "High|Low": "7 Days",
      "Medium|Critical": "36 Hours",
      "Medium|High": "36 Hours",
      "Medium|Medium": "36 Hours",
      "Medium|Low": "7 Days",
      "Low|Critical": "7 Days",
      "Low|High": "7 Days",
      "Low|Medium": "7 Days",
      "Low|Low": "7 Days",
    },
  },
  {
    customer: ["Orange MALI SA"],
    mappings: {
      "Critical|Critical": "4 Hours",
      "Critical|High": "12 Hours",
      "Critical|Medium": "12 Hours",
      "Critical|Low": "24 Hours",
      "High|Critical": "12 Hours",
      "High|High": "12 Hours",
      "High|Medium": "12 Hours",
      "High|Low": "24 Hours",
      "Medium|Critical": "12 Hours",
      "Medium|High": "12 Hours",
      "Medium|Medium": "12 Hours",
      "Medium|Low": "24 Hours",
      "Low|Critical": "24 Hours",
      "Low|High": "24 Hours",
      "Low|Medium": "24 Hours",
      "Low|Low": "24 Hours",
    },
  },
  {
    customer: ["Vodacom DRC" ,"MTN Nigeria", "Vodacom south Africa" , "Vodacom Mozambique"],
    mappings: {
      "Critical|Critical": "2 Hours",
      "Critical|High": "2 Hours",
      "Critical|Medium": "4 Hours",
      "Critical|Low": "8 Hours",
      "High|Critical": "2 Hours",
      "High|High": "2 Hours",
      "High|Medium": "4 Hours",
      "High|Low": "8 Hours",
      "Medium|Critical": "4 Hours",
      "Medium|High": "4 Hours",
      "Medium|Medium": "4 Hours",
      "Medium|Low": "8 Hours",
      "Low|Critical": "8 Hours",
      "Low|High": "8 Hours",
      "Low|Medium": "8 Hours",
      "Low|Low": "8 Hours",
    },
  },
 {
    customer: ["Telebras"],
    mappings: {
      "Critical|Critical": "48 Hours",
      "Critical|High": "48 Hours",
      "Critical|Medium": "48 Hours",
      "Critical|Low": "48 Hours",
      "High|Critical": "50 hours ",
      "High|High": "50 hours ",
      "High|Medium": "52 Hours ",
      "High|Low": "54 Hours ",
      "Medium|Critical": "52 Hours",
      "Medium|High": "52 Hours",
      "Medium|Medium": "52 Hours",
      "Medium|Low": "54 Hours",
      "Low|Critical": "54 Hours",
      "Low|High": "54 Hours",
      "Low|Medium": "54 Hours",
      "Low|Low": "54 Hours",
    },
  },
{
    customer: ["Orange Burkina Faso"],
    mappings: {
      "Critical|Critical": "4 Hours",
      "Critical|High": "8 Hours",
      "Critical|Medium": "36 Hours",
      "Critical|Low": "7 Days",
      "High|Critical": "8 Hours",
      "High|High": "8 Hours",
      "High|Medium": "36 Hours",
      "High|Low": "7 Days",
      "Medium|Critical": "36 Hours",
      "Medium|High": "36 Hours",
      "Medium|Medium": "36 Hours",
      "Medium|Low": "7 Days",
      "Low|Critical": "7 Days",
      "Low|High": "7 Days",
      "Low|Medium": "7 Days",
      "Low|Low": "7 Days",
    },
  },
  {
    customer: ["Petrobras"],
    mappings: {
      "Critical|Critical": "5 Hours",
      "Critical|High": "72 Hours",
      "Critical|Medium": "72 Hours",
      "Critical|Low": "7 Days",
      "High|Critical": "72 Hours",
      "High|High": "72 Hours",
      "High|Medium": "72 Hours",
      "High|Low": "7 Days",
      "Medium|Critical": "72 Hours",
      "Medium|High": "72 Hours",
      "Medium|Medium": "72 Hours",
      "Medium|Low": "30 Days",
      "Low|Critical": "30 Days",
      "Low|High": "30 Days",
      "Low|Medium": "30 Days",
      "Low|Low": "30 Days",
    },
  },
];
